import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetAllLeadChannelsResponseTO } from 'models/Leads';
import API from 'services/API';

export const LEAD_CHANNELS_BASE_QUERY_KEY = 'lead-channels';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetAllLeadChannelsResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchLeadChannelsArgs = ReactQueryOptions;

const useFetchLeadChannels = ({
  enabled = true,
  ...options
}: UseFetchLeadChannelsArgs = {}) => {
  return useAppQuery<GetAllLeadChannelsResponseTO>({
    queryKey: [LEAD_CHANNELS_BASE_QUERY_KEY, 'list'],
    queryFn: async () => {
      const response = await API.get<GetAllLeadChannelsResponseTO>(
        '/api/internal/leads-channels',
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchLeadChannels;
